/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('mongoSourceEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./mongo-source-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          $scope.bodyDataOptions = {
            lineWrapping: true,
            lineNumbers: true,
            mode: 'javascript',
          };
        },
      ],
    };
  },
]);
